import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../../Components/Layout";
import AttendeeDetials from "../../../Components/OrderMgt/Attendee/AttendeeDetials";
import useHttpHook from "../../../Hooks/HttpHook";
import { GetAllAttendeeDetails } from "../../../utils/ApiConstant";
import { OrderLanguage } from "../../../utils/Languages";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const AttendeeDetailsPage = () => {
  const { attendeeId } = useParams();

  const [details, setDetails] = useState({});
  const [loading, sendRequest, error] = useHttpHook();
  const query = new URLSearchParams(window.location.search);
  const redirectUrl = query.get("redirectUrl");

  useEffect(() => {
    getDetails();
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const getDetails = async () => {
    try {
      let response = await sendRequest(
        `${GetAllAttendeeDetails}/${attendeeId}`,
        {
          method: "get",
        }
      );
      if (response?.status === 1) {
        setDetails(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout
      Heading={OrderLanguage.Attendees.details.heading}
      TitleMark={true}
      TitleMarkClassName="event-attendee-detail-title-mark"
      TitleClassName="event-attendee-detail-title"
      HeadClassName="event-attendee-detail-head"
      DetailsHead
      ExtraclassName="event-attendee-detail-panel"
      activeMenuId="attendees"
      BackAction={
        // userDetails && page === "myevents" ? "/organizer/MyEvents" : "/"
        redirectUrl
      }
    >
      <AttendeeDetials
        isLoading={loading}
        isError={error}
        details={details}
        setDetails={setDetails}
      />
    </Layout>
  );
};

export default AttendeeDetailsPage;
